var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
const SvgSwordHeavy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 120,
  height: 32,
  viewBox: "0 0 120 32",
  fill: "currentColor"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M80.832 10.368h35.328l-14.944 11.68H43.488l-1.632-2.24-1.248-1.056-1.568-.704-1.44-.256-.96-.128-.608.352-2.336.448-1.472-.768-1.088.224-.576 8.928h-.8l-3.008-9.088-1.92-1.248H8.8l-.48.32-.48.416-.288.416h-2.88l-.736-.864v-5.152l1.44-.736h2.432l.992 1.28h15.84l3.52-1.76h14.752l.448-.672h4.672l1.568 1.76h29.568zM61.76 19.2v-1.248h-9.28V19.2zm3.296 0h33.376l-1.024-1.248H65.056zm34.784-1.728 4-2.976v-.672h-4.032v2.048l-.704.64z"
})));
const Memo = /*#__PURE__*/memo(SvgSwordHeavy);
export default Memo;